var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger-container",on:{"click":_vm.toggleClick}},[_c('i',{class:_vm.isActive ? 'el-icon-s-fold' : 'el-icon-s-unfold',staticStyle:{"font-size":"20px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }